export default __webpack_public_path__ + "static/media/icon-menu.f571e5fc.svg";